import { render, staticRenderFns } from "./Processos.vue?vue&type=template&id=4c98b7e9&"
import script from "./Processos.vue?vue&type=script&lang=js&"
export * from "./Processos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports